export default "__VITE_ASSET__Bhws5M0K__"